import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getErrorCode } from '@core/utils/get-error-code';
import { TranslateService } from '@ngx-translate/core';
import { sentry } from 'sentry';
import { FuseTranslationLoaderService } from '../../../@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { KNOW_ERRORS } from './know-errors';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly snackBar: MatSnackBar,
    private readonly translateService: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  /**
   * @deprecated Use CustomMessagesService instead
   */
  success(key: string, interpolateParams?: Record<string, string>): void {
    const message = this.translateService.instant(key, interpolateParams);
    this.snackBar.open(message, null, {
      duration: 5000,
      horizontalPosition: 'left'
    });
  }

  /**
   * @deprecated Use CustomMessagesService instead
   */
  warn(key: string, interpolateParams?: Record<string, string | number>): void {
    const message = this.translateService.instant(key, interpolateParams);
    this.snackBar.open(message, null, {
      duration: 5000,
      horizontalPosition: 'left'
    });
  }

  /**
   * @deprecated Use CustomMessagesService instead
   */
  error(err: any, errTranslatedKey?: string): void {
    const code = getErrorCode(err);
    const key = KNOW_ERRORS[code] || errTranslatedKey || 'ERRORS.UNKNOWN';

    if (!KNOW_ERRORS[code]) {
      sentry.captureException(err);
    }

    const message = this.translateService.instant(key);
    this.snackBar.open(message, null, {
      duration: 5000,
      horizontalPosition: 'left'
    });
  }
}
